module.exports = __webpack_public_path__ + "static/media/eu_feb_2025.d19fe2aa.webp";